import { render, staticRenderFns } from "./Cutoff.vue?vue&type=template&id=72d161c0&scoped=true"
import script from "./Cutoff.vue?vue&type=script&lang=js"
export * from "./Cutoff.vue?vue&type=script&lang=js"
import style0 from "./Cutoff.vue?vue&type=style&index=0&id=72d161c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d161c0",
  null
  
)

export default component.exports